export function calculateSubMenuCoordinates(anchorRect: DOMRect, subMenuRect: DOMRect) {
    const left = anchorRect.left + anchorRect.width / 2 - subMenuRect.width / 2;

    const top = anchorRect.top + anchorRect.height + 10;

    return {
        left,
        top,
    };
}
